'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { Icon } from '@/components/ui/icon';
import { GiftIcon } from '@/components/ui/icon/glyphs';
import { usePendingGiftCount } from '@/hooks/gifts/use-pending-gift-count';
import { Link } from '@/i18n/navigation';
import { checkGate } from '@/lib/analytics';
export interface PendingGiftsBadgeProps {
  /** Locale prefix for the link, e.g. `/en` — defaults to root. */
  localePrefix?: string;
  /** Optional className passthrough. */
  className?: string;
}

/**
 * Header surface that shows the number of pending received gifts (FR-057).
 * Hidden when count is zero or the request fails — never blocks the header.
 */
export function PendingGiftsBadge(props) {
  const $ = _c(11);
  const t = useTranslations("gift.pending_badge");
  const {
    data,
    status
  } = usePendingGiftCount();
  if (!checkGate("gifting")) {
    return null;
  }
  if (status !== "success") {
    return null;
  }
  const count = data?.pendingCount ?? 0;
  if (count <= 0) {
    return null;
  }
  const href = `${props.localePrefix ?? ""}/gifts`;
  const t0 = props.className ?? "inline-flex items-center gap-1.5 rounded-full bg-foreground-primary/10 px-2.5 py-1 text-caption font-medium text-foreground-primary hover:bg-foreground-primary/20";
  let t1;
  if ($[0] !== count || $[1] !== t) {
    t1 = t("label", {
      count
    });
    $[0] = count;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Icon icon={GiftIcon} className="size-3.5" aria-hidden="true" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== count) {
    t3 = <span>{count}</span>;
    $[4] = count;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== href || $[7] !== t0 || $[8] !== t1 || $[9] !== t3) {
    t4 = <Link href={href} className={t0} aria-label={t1}>{t2}{t3}</Link>;
    $[6] = href;
    $[7] = t0;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}